(function () {
  const assumptions = {
    bottlesPerOccupiedRoomNight: 3.2,
    smallBottleVolumeMl: 30,
    largeBottleVolumeMl: 300,
    pouchVolumeMl: 300,
    smallBottlePlasticG: 6,
    largeBottlePlasticG: 35,
    pouchPlasticG: 11,
    kgPlasticToKgCo2e: 2.5
  };

  const labels = {
    locale: "en-AU",
    tonne: "tonnes",
    kg: "kg",
    awaiting: "Awaiting input",
    smallAwaiting: "Click Calculate Impact to estimate annual bottle use.",
    largeAwaiting: "Click Calculate Impact to estimate annual 300ml bottle equivalents.",
    ecoAwaiting: "Click Calculate Impact to estimate annual Pump Eco pouch equivalents.",
    baseline: "Calculated against the single-use bottle baseline.",
    reductionPending: "-- less plastic",
    roomNights: (value) => `${value} room nights`,
    smallDetail: (value) => `${value} single-use bottles per year.`,
    largeDetail: (value) => `${value} 300ml bottle equivalents per year.`,
    ecoDetail: (value) => `${value} Pump Eco pouch equivalents per year.`,
    perYear: (value) => `${value}/year`,
    plasticSaved: (value) => `Avoids ${value} of packaging plastic per year.`,
    reductionRate: (value) => `${value}% less plastic`,
    statusCalculated: (rooms, occupancy) => `Calculated for ${rooms} rooms at ${occupancy}% average occupancy.`,
    statusChanged: "Inputs changed. Click Calculate Impact to refresh the results."
  };

  const fields = {
    rooms: document.querySelector("#rooms"),
    occupancy: document.querySelector("#occupancy")
  };

  const calculator = document.querySelector("#calculator");

  const output = {
    roomNights: document.querySelector("#roomNights"),
    smallPlastic: document.querySelector("#smallPlastic"),
    largePlastic: document.querySelector("#largePlastic"),
    ecoPlastic: document.querySelector("#ecoPlastic"),
    smallDetail: document.querySelector("#smallDetail"),
    largeDetail: document.querySelector("#largeDetail"),
    ecoDetail: document.querySelector("#ecoDetail"),
    smallPlasticBarLabel: document.querySelector("#smallPlasticBarLabel"),
    largePlasticBarLabel: document.querySelector("#largePlasticBarLabel"),
    ecoPlasticBarLabel: document.querySelector("#ecoPlasticBarLabel"),
    smallBar: document.querySelector("#smallBar"),
    largeBar: document.querySelector("#largeBar"),
    ecoBar: document.querySelector("#ecoBar"),
    largeCarbonSaved: document.querySelector("#largeCarbonSaved"),
    ecoCarbonSaved: document.querySelector("#ecoCarbonSaved"),
    largePlasticSaved: document.querySelector("#largePlasticSaved"),
    ecoPlasticSaved: document.querySelector("#ecoPlasticSaved"),
    largeReductionRate: document.querySelector("#largeReductionRate"),
    ecoReductionRate: document.querySelector("#ecoReductionRate"),
    calculationStatus: document.querySelector("#calculationStatus")
  };

  const wholeNumber = new Intl.NumberFormat(labels.locale, { maximumFractionDigits: 0 });
  const oneDecimal  = new Intl.NumberFormat(labels.locale, { maximumFractionDigits: 1 });
  const percent     = new Intl.NumberFormat(labels.locale, { maximumFractionDigits: 0 });

  function readValue(field) {
    const v = Number.parseFloat(field.value);
    const d = Number.parseFloat(field.dataset.default);
    return (Number.isFinite(v) && v > 0) ? v : (Number.isFinite(d) ? d : 0);
  }

  function formatKg(value) {
    return value >= 1000
      ? `${oneDecimal.format(value / 1000)} ${labels.tonne}`
      : `${wholeNumber.format(value)} ${labels.kg}`;
  }

  function setBar(el, value, max) {
    const w = max > 0 ? (value / max) * 100 : 0;
    el.style.width = value > 0 ? `${Math.max(2, Math.min(100, w))}%` : "0%";
  }

  function setTextWithRoll(el, text) {
    el.classList.remove("wic-is-rolling");
    void el.offsetWidth;
    el.textContent = text;
    el.classList.add("wic-is-rolling");
  }

  function setAwaitingResults() {
    output.roomNights.textContent = labels.awaiting;
    output.smallPlastic.textContent = "--";
    output.largePlastic.textContent = "--";
    output.ecoPlastic.textContent = "--";
    output.smallDetail.textContent = labels.smallAwaiting;
    output.largeDetail.textContent = labels.largeAwaiting;
    output.ecoDetail.textContent = labels.ecoAwaiting;
    output.smallPlasticBarLabel.textContent = labels.perYear("--");
    output.largePlasticBarLabel.textContent = labels.perYear("--");
    output.ecoPlasticBarLabel.textContent = labels.perYear("--");
    output.largeCarbonSaved.textContent = "-- CO2e";
    output.ecoCarbonSaved.textContent = "-- CO2e";
    output.largePlasticSaved.textContent = labels.baseline;
    output.ecoPlasticSaved.textContent = labels.baseline;
    output.largeReductionRate.textContent = labels.reductionPending;
    output.ecoReductionRate.textContent = labels.reductionPending;
    setBar(output.smallBar, 0, 1);
    setBar(output.largeBar, 0, 1);
    setBar(output.ecoBar, 0, 1);
  }

  function calculate() {
    const rooms = readValue(fields.rooms);
    const occupancy = Math.min(readValue(fields.occupancy), 100) / 100;
    const annualRoomNights = rooms * occupancy * 365;
    const smallBottles = annualRoomNights * assumptions.bottlesPerOccupiedRoomNight;
    const annualLiquidMl = smallBottles * assumptions.smallBottleVolumeMl;
    const largeBottles = annualLiquidMl / assumptions.largeBottleVolumeMl;
    const pouches = annualLiquidMl / assumptions.pouchVolumeMl;
    const smallPlasticKg = smallBottles * assumptions.smallBottlePlasticG / 1000;
    const largePlasticKg = largeBottles * assumptions.largeBottlePlasticG / 1000;
    const ecoPlasticKg = pouches * assumptions.pouchPlasticG / 1000;
    const largeSavedKg = Math.max(0, smallPlasticKg - largePlasticKg);
    const ecoSavedKg = Math.max(0, smallPlasticKg - ecoPlasticKg);
    const largeReductionRate = smallPlasticKg > 0 ? (largeSavedKg / smallPlasticKg) * 100 : 0;
    const ecoReductionRate = smallPlasticKg > 0 ? (ecoSavedKg / smallPlasticKg) * 100 : 0;
    const largeCarbonKg = largeSavedKg * assumptions.kgPlasticToKgCo2e;
    const ecoCarbonKg = ecoSavedKg * assumptions.kgPlasticToKgCo2e;

    output.roomNights.textContent = labels.roomNights(wholeNumber.format(annualRoomNights));
    setTextWithRoll(output.smallPlastic, formatKg(smallPlasticKg));
    setTextWithRoll(output.largePlastic, formatKg(largePlasticKg));
    setTextWithRoll(output.ecoPlastic, formatKg(ecoPlasticKg));
    output.smallDetail.textContent = labels.smallDetail(wholeNumber.format(smallBottles));
    output.largeDetail.textContent = labels.largeDetail(wholeNumber.format(largeBottles));
    output.ecoDetail.textContent = labels.ecoDetail(wholeNumber.format(pouches));
    output.smallPlasticBarLabel.textContent = labels.perYear(formatKg(smallPlasticKg));
    output.largePlasticBarLabel.textContent = labels.perYear(formatKg(largePlasticKg));
    output.ecoPlasticBarLabel.textContent = labels.perYear(formatKg(ecoPlasticKg));
    setTextWithRoll(output.largeCarbonSaved, `${formatKg(largeCarbonKg)} CO2e`);
    setTextWithRoll(output.ecoCarbonSaved, `${formatKg(ecoCarbonKg)} CO2e`);
    output.largePlasticSaved.textContent = labels.plasticSaved(formatKg(largeSavedKg));
    output.ecoPlasticSaved.textContent = labels.plasticSaved(formatKg(ecoSavedKg));
    output.largeReductionRate.textContent = labels.reductionRate(percent.format(largeReductionRate));
    output.ecoReductionRate.textContent = labels.reductionRate(percent.format(ecoReductionRate));
    output.calculationStatus.textContent = labels.statusCalculated(wholeNumber.format(rooms), wholeNumber.format(occupancy * 100));
    setBar(output.smallBar, smallPlasticKg, smallPlasticKg);
    setBar(output.largeBar, largePlasticKg, smallPlasticKg);
    setBar(output.ecoBar, ecoPlasticKg, smallPlasticKg);
    const resultsEl = document.querySelector("#results");
    const offset = 160;
    window.scrollTo({
      top: resultsEl.getBoundingClientRect().top + window.scrollY - offset,
      behavior: "smooth"
    });
  }

  calculator.addEventListener("submit", (e) => { e.preventDefault(); calculate(); });
  Object.values(fields).forEach((f) => {
    f.addEventListener("input", () => {
      output.calculationStatus.textContent = labels.statusChanged;
    });
  });

  setAwaitingResults();
})();
